import { adminClient, inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { ac, roles } from "./permissions";
import { SESSION_CHECK_RETRY } from "./session-cache";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
  fetchOptions: { retry: SESSION_CHECK_RETRY },
  plugins: [
    adminClient({ ac, roles }),
    inferAdditionalFields({ user: { ieFirm: { type: "string", required: false, input: false } } }),
  ],
});

export const { signIn, signUp, signOut, useSession } = authClient;
